import React from 'react';
import Row from 'src/frontend-common/components/Row';
import { styled, Typography } from '@mui/material';

const Stepper: React.FC<{ steps: string[]; currentStep: number }> = ({ steps, currentStep }) => {
  return (
    <StepperWrapper>
      {steps.map((step, index) => {
        const current = currentStep === index ? 'true' : undefined;
        return (
          <React.Fragment key={`${step}-${index}`}>
            <Row>
              <NumberCircle current={current}>{index + 1}</NumberCircle>
              <StepLabel variant="body2" current={current}>
                {step}
              </StepLabel>
            </Row>
            {steps.length > index + 1 && <RightLine role="line" />}
          </React.Fragment>
        );
      })}
    </StepperWrapper>
  );
};

export default Stepper;

const StepperWrapper = styled(Row)(() => ({
  justifyContent: 'flex-start',
  alignItems: 'center',
  '& > div': {
    display: 'flex',
    alignItems: 'center',
  },
}));

const marginRight = 1.5;

const NumberCircle = styled('div')<{ current?: 'true' }>(({ theme, current }) => ({
  width: 35,
  height: 35,
  borderRadius: '50%',
  marginRight: theme.spacing(marginRight),
  backgroundColor: current === 'true' ? theme.palette.primary.main : theme.palette.grey[50],
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: current === 'true' ? 'white' : '#8d8d8d',
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    width: 25,
    height: 25,
    marginRight: theme.spacing(1),
  },
}));
const StepLabel = styled(Typography)<{ current?: 'true' }>(({ theme, current }) => ({
  marginRight: theme.spacing(marginRight),
  fontWeight: 600,
  color: current === 'true' ? theme.palette.primary.main : '#8d8d8d',
}));

const RightLine = styled('div')(({ theme }) => ({
  width: `100%`,
  height: 5,
  borderRadius: 4,
  backgroundColor: theme.palette.grey[50],
  marginRight: theme.spacing(marginRight),
  [theme.breakpoints.down('xl')]: {
    marginRight: theme.spacing(0.5),
  },
}));
